import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import useUIEditor from 'assets/hooks/uiEditor/UIEditor';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { UICommand } from 'assets/utils/dom/Commands';

export default function ClaimJobEmailTemplateTags() {
  const { lang } = getLocales();
  const uiEditor = useUIEditor();
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-plus" />}
      buttonBody={lang.addPlaceholder}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      tabIndex={null}
      htmlElementProps={{
        title: lang.addEmailTemplatePlaceholder,
      }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <DataMap
          data={[
            { id: '{{IEmailTemplate_SenderName}}', title: lang.senderName },
            { id: '{{IEmailTemplate_SenderEmail}}', title: lang.senderEmail },
            { id: '{{ClaimJob_StatusCode}}', title: lang.claimJobStatus },
            { id: '{{ClaimJob_AuthorizationNumber}}', title: lang.claimJobAuthorizationNumber },
            { id: '{{ClaimJobDetail_Comments}}', title: lang.claimJobNotes },
            { id: '{{ClaimJobDetail_Details}}', title: `${lang.claimJob} ${lang.details}` },
            { id: '{{ClaimJobDetail_PartDetails}}', title: `${lang.claimJob} ${lang.part} ${lang.details}` },
            { id: '{{ClaimJobDetail_LabourDetails}}', title: `${lang.claimJob} ${lang.labour} ${lang.details}` },
            { id: '{{ClaimJobDetail_OtherDetails}}', title: `${lang.claimJob} ${lang.other} ${lang.details}` },
            {
              id: '{{ClaimJobDetail_DeductibleDetails}}',
              title: `${lang.claimJob} ${lang.deductible} ${lang.details}`,
            },
            {
              id: '{{ClaimJobDetail_DecidedDate}}',
              title: `${lang.claimJob} ${lang.decidedDate}`,
            },
            { id: '{{ClaimJobDetail_Number}}', title: `${lang.claimJob} ${lang.number}` },
            { id: '{{ClaimJobDetail_TotalAmount}}', title: lang.totalAmount },
            { id: '{{ClaimJobDetail_TotalTaxAmount}}', title: lang.totalTax },
            { id: '{{ClaimJobDetail_TotalAmountWithTax}}', title: lang.totalAmountWithTaxes },
            { id: '{{ClaimJobDetail_TotalDeductibleAmount}}', title: `${lang.total} ${lang.deductible}` },
            {
              id: '{{ClaimJobDetail_TotalAmountWithoutDeductible}}',
              title: `${lang.total} ${lang.without} ${lang.deductible}`,
            },
            {
              id: '{{ClaimJobDetail_AggregateDetails}}',
              title: `${lang.claimJob} ${lang.aggregate}  ${lang.details}`,
            },
            {
              id: '{{ClaimJobDetail_PaymentMethods}}',
              title: `${lang.payees} ${lang.paymentMethod}s`,
            },
            { id: '{{ClaimType_Name}}', title: `${lang.claimType} ${lang.name}` },
            { id: '{{Claim_ContactName}}', title: lang.contactName },
            { id: '{{Claim_ContactPhone}}', title: lang.phoneNumber },
            { id: '{{Claim_ContactEmail}}', title: lang.email },
            { id: '{{ClaimUrl}}', title: `${lang.claim} ${lang.url}` },
            { id: '{{ClaimPayee_Name}}', title: `${lang.claim} ${lang.payee} ${lang.contactName}` },
            { id: '{{ClaimPayee_PhoneNumber}}', title: `${lang.claim} ${lang.payee} ${lang.phoneNumber}` },
            { id: '{{ClaimPayee_Email}}', title: `${lang.claim} ${lang.payee} ${lang.email}` },
            { id: '{{Claim_Number}}', title: lang.claimNumber },
            { id: '{{ClaimDetail_ClaimExternalComments}}', title: lang.claimExternalComments },
            { id: '{{Contract_AppNumberWithRevision}}', title: lang.contractNumber },
            { id: '{{Dealer_Name}}', title: lang.dealer },
            { id: '{{Client_FirstName}} {{Client_LastName}}', title: lang.client },
            { id: '{{Vehicle_Vin}}', title: lang.vin },
          ]}
          render={({ data }) => (
            <Button
              key={data.id}
              class={ThemeButtonMenuItem}
              render={data.title}
              onClick={(data) => uiEditor.applyUiCommand(UICommand.insertHTML, data)}
              data={data.id}
            />
          )}
        />
      }
    />
  );
}
